<template>
  <a-form-model ref="form" :model="form.data" :rules="form.rules">
    <a-form-model-item label="类型">
      <a-select v-model="form.data.type" placeholder="请选择">
        <a-select-option title="固定文本" value="TEXT"></a-select-option>
        <a-select-option title="日期类型" value="DATETIME"></a-select-option>
        <a-select-option title="自动增长" value="AUTO"></a-select-option>
      </a-select>
    </a-form-model-item>
    <a-form-model-item label="文本内容" v-if="form.data.type === 'TEXT'">
      <a-input v-model="form.data.node"/>
    </a-form-model-item>
    <a-form-model-item label="日期格式" v-if="form.data.type === 'DATETIME'">
      <a-select v-model="form.data.node" placeholder="请选择">
        <a-select-option title="年" value="yyyy">
          <span style="float: left">年</span>
          <span style="float: right; color: #8492a6; font-size: 13px">2019</span>
        </a-select-option>
        <a-select-option title="月" value="MM">
          <span style="float: left">月</span>
          <span style="float: right; color: #8492a6; font-size: 13px">03</span>
        </a-select-option>
        <a-select-option title="日" value="dd">
          <span style="float: left">日</span>
          <span style="float: right; color: #8492a6; font-size: 13px">07</span>
        </a-select-option>
        <a-select-option title="年月" value="yyyyMM">
          <span style="float: left">年月</span>
          <span style="float: right; color: #8492a6; font-size: 13px">201903</span>
        </a-select-option>
        <a-select-option title="年月日" value="yyyyMMdd">
          <span style="float: left">年月日</span>
          <span style="float: right; color: #8492a6; font-size: 13px">20190307</span>
        </a-select-option>
      </a-select>
    </a-form-model-item>
    <a-form-model-item label="重复周期" v-if="form.data.type === 'AUTO'">
      <a-select v-model="form.data.cycle" placeholder="请选择">
        <a-select-option title="不重置" value="NONE"></a-select-option>
        <a-select-option title="每日重置" value="DAY"></a-select-option>
        <a-select-option title="每周重置" value="WEEK"></a-select-option>
        <a-select-option title="每月重置" value="MONTH"></a-select-option>
        <a-select-option title="每年重置" value="YEAR"></a-select-option>
      </a-select>
    </a-form-model-item>
    <a-form-model-item label="步长" v-if="form.data.type === 'AUTO'">
      <a-input-number v-model="form.data.step"/>
    </a-form-model-item>
    <a-form-model-item label="长度" v-if="form.data.type === 'AUTO'">
      <a-input-number v-model="form.data.length"/>
    </a-form-model-item>
    <a-form-model-item label="当前值" v-if="form.data.type === 'AUTO'">
      <a-input v-model="form.data.currentValue"/>
    </a-form-model-item>
    <div style="text-align: right">
      <a-button
        type="primary"
        v-if="!sysCodingRuleDetailId" @click="onAdd" :disabled="form.disabled">
        {{ $t('CREATE') || '创建' }}
        <i class="el-icon-loading el-icon--right" v-if="form.disabled"/>
      </a-button>
      <a-button
        type="primary"
        v-if="sysCodingRuleDetailId" @click="onUpdate" :disabled="form.disabled">{{ $t('UPDATE') || '创建' }}
        <i class="el-icon-loading el-icon--right" v-if="form.disabled"/>
      </a-button>
      <a-button @click="onCancel">取消</a-button>
    </div>
  </a-form-model>
</template>

<script>
import {
  _querySysCodingRuleDetail,
  _addSysCodingRuleDetail,
  _updateSysCodingRuleDetail,
} from '@/api/sys/sysCodingRuleDetailApi';

async function getSysCodingRuleDetail() {
  const result = await _querySysCodingRuleDetail(this.codingRuleId, this.sysCodingRuleDetailId);
  if (result) {
    this.form.data.type = result.sysCodingRuleDetail.type;
    this.form.data.node = result.sysCodingRuleDetail.node;
    this.form.data.sysCodingRuleId = result.sysCodingRuleDetail.sysCodingRuleId;
    this.form.data.cycle = result.sysCodingRuleDetail.cycle;
    this.form.data.currentValue = result.sysCodingRuleDetail.currentValue;
    this.form.data.step = result.sysCodingRuleDetail.step;
    this.form.data.length = result.sysCodingRuleDetail.length;
  }
}

async function onAdd() {
  this.$refs.form.validate(async (valid) => {
    if (valid) {
      const result = await _addSysCodingRuleDetail(this.codingRuleId, {
        type: this.form.data.type,
        node: this.form.data.node,
        cycle: this.form.data.cycle,
        currentValue: this.form.data.currentValue,
        step: this.form.data.step,
        length: this.form.data.length,
      });
      if (result) {
        if (this.onSubmitHandler) {
          this.$message.success(this.$t('ADD_SUCCESS'));
          this.onSubmitHandler();
        }
      }
    }
  });
}

async function onUpdate() {
  this.$refs.form.validate(async (valid) => {
    if (valid) {
      const result = await _updateSysCodingRuleDetail(this.codingRuleId, this.sysCodingRuleDetailId,
        {
          type: this.form.data.type,
          node: this.form.data.node,
          sysCodingRuleId: this.form.data.sysCodingRuleId,
          cycle: this.form.data.cycle,
          currentValue: this.form.data.currentValue,
          step: this.form.data.step,
          length: this.form.data.length,
        });
      if (result) {
        if (this.onSubmitHandler) {
          this.$message.success(this.$t('UPDATE_SUCCESS'));
          this.onSubmitHandler();
        }
      }
    }
  });
}

function onCancel() {
  if (this.onCancelHandler) {
    this.onCancelHandler();
  }
}

export default {
  name: 'SysCodingRuleDetailEdit',
  props: {
    sysCodingRuleDetailId: String,
    codingRuleId: String,
    onSubmitHandler: Function,
    onCancelHandler: Function,
  },
  watch: {
    sysCodingRuleDetailId() {
      if (this.sysCodingRuleDetailId) {
        this.getSysCodingRuleDetail();
      }
    },
  },
  methods: {
    onAdd,
    onUpdate,
    onCancel,
    getSysCodingRuleDetail,
  },
  data() {
    return {
      form: {
        data: {
          type: 'AUTO',
          node: '',
          cycle: 'NONE',
          currentValue: '',
          step: 1,
          length: 5,
        },
        title: '',
      },
    };
  },
  created() {
    if (this.sysCodingRuleDetailId) {
      this.getSysCodingRuleDetail();
    }
  },
};
</script>
